import { Component } from '@angular/core';
import { AppState } from '@core/store';
import { selectMasterOrderData } from '@core/store/order';
import { MasterOrderData } from '@core/store/order/order-state-models';
import { Store } from '@ngrx/store';
import { BaseComponent } from '@shared/components/base-component/base-component';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-master-order-payment-order-information',
  templateUrl: './master-order-payment-order-information.component.html',
  styleUrls: ['./master-order-payment-order-information.component.scss'],
})
export class MasterOrderPaymentOrderInformationComponent extends BaseComponent {
  public masterOrderData$: Observable<MasterOrderData>;

  constructor(private store$: Store<AppState>) {
    super();

    this.masterOrderData$ = this.store$
      .select(selectMasterOrderData)
      .pipe(filter((masterOrderData) => !!masterOrderData));
  }
}
